import { render, staticRenderFns } from "./FullScreenKongSkeleton.vue?vue&type=template&id=aa696f62&scoped=true&"
import script from "./FullScreenKongSkeleton.vue?vue&type=script&lang=js&"
export * from "./FullScreenKongSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenKongSkeleton.vue?vue&type=style&index=0&id=aa696f62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa696f62",
  null
  
)

export default component.exports